// Shared genetic-algorithm constants used by:
//   - EvolutionChapter in src/App.tsx (the live React simulation)
//   - scripts/sim-evolution.ts (headless tuner)
//
// Tuned so first carrot-reach lands at gen ~20 with ~50% gen-1 deaths
// and visible mutation breakouts. Change here = change in both places.

export const GA = {
  POP: 28,
  GENES: 800,
  MAX_STEPS: 800,
  FORCE: 0.35,
  DAMPING: 0.94,
  MAX_SPEED: 6,
  BIAS_X: 0.04,
  GENE_HALF_RANGE: 1.5, // gene values in BIAS_X ± GENE_HALF_RANGE
  ELITE_COUNT: 5, // # crowned during showcase
  ELITE_KEEP: 2, // # of unchanged-DNA babies in next gen
  IMMIGRANTS: 4, // # fresh-random bugs each gen
  MUT_RATE: 0.05,
  MUT_DRIFT: 0.5, // drift mutation magnitude
  BIG_JUMP: 0.05, // within a mutation, chance of a full re-roll
  TOP_FRAC: 0.3, // top fraction of parents that breed
  TARGET_R: 26, // carrot reach radius (px)
  SHOWCASE_MS: 1600,
} as const;
